export const VIEWPORT_BOUNDARY_SMALL = 480;
export const VIEWPORT_BOUNDARY_MIDDLE = 768;

export const MEDIA_QUERY_PC = `screen and (min-width: ${VIEWPORT_BOUNDARY_MIDDLE + 1}px)`;
export const MEDIA_QUERY_MOBILE_TABLET = `screen and (max-width: ${VIEWPORT_BOUNDARY_MIDDLE}px)`;
export const MEDIA_QUERY_TABLET = `screen and (max-width: ${VIEWPORT_BOUNDARY_MIDDLE}px) and (min-width: ${VIEWPORT_BOUNDARY_SMALL +
  1}px`;
